"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "damages.performInsurerEdi";
  var componentName = "performInsurerEdi";

  var bindings = {
    resolve: "<?",
    damage: "<?"
  };

  var templateUrl = "app/pages/damages/performInsurerEdi/performInsurerEdi.component.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $timeout, $window, DamagesService, VehiclesService, UsersService, DocumentRequestsService, CustomListsService, ModalService) {
      _classCallCheck(this, Controller);

      console.log(moduleName + "/" + componentName);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.$window = $window;

      this.DamagesService = DamagesService;
      this.UsersService = UsersService;
      this.VehiclesService = VehiclesService;
      this.CustomListsService = CustomListsService;
      this.DocumentRequestsService = DocumentRequestsService;

      this.ModalService = ModalService;
    }

    _createClass(Controller, [{
      key: "askSomeoneToUploadDocument",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.ModalService.openComponent("ask-someone", {
                    damage: this.damage,
                    size: "lg"
                  });

                case 2:
                  _context.next = 4;
                  return this.checkDocs();

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function askSomeoneToUploadDocument() {
          return _ref.apply(this, arguments);
        }

        return askSomeoneToUploadDocument;
      }()
    }, {
      key: "askSomeoneRemind",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_id) {
          var response;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return swal({
                    //title: "",
                    text: "Confirmez-vous le renvoi de la demande ?",
                    icon: "warning",
                    dangerMode: true,
                    buttons: {
                      cancel: "Non",
                      confirm: "Oui"
                    }
                  });

                case 2:
                  response = _context2.sent;

                  if (!(response == true)) {
                    _context2.next = 17;
                    break;
                  }

                  Notiflix.Loading.standard("Envoi en cours ...<br>Veuillez patienter");
                  _context2.prev = 5;
                  _context2.next = 8;
                  return this.DamagesService.customPost("documentRequest/" + _id);

                case 8:
                  Notiflix.Loading.remove();
                  Notiflix.Notify.success("Envoi réussi");
                  _context2.next = 17;
                  break;

                case 12:
                  _context2.prev = 12;
                  _context2.t0 = _context2["catch"](5);

                  console.error(_context2.t0);
                  Notiflix.Loading.remove();
                  Notiflix.Notify.failure("Echec de l'envoi");

                case 17:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[5, 12]]);
        }));

        function askSomeoneRemind(_x) {
          return _ref2.apply(this, arguments);
        }

        return askSomeoneRemind;
      }()
    }, {
      key: "askSomeoneEdit",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_id) {
          var _this = this;

          var value;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  _context4.next = 2;
                  return this.ModalService.open("documentRequests/documentRequest", { _id: _id }).then(function () {
                    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(value) {
                      return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              console.log(value);
                              return _context3.abrupt("return", value);

                            case 2:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3, _this);
                    }));

                    return function (_x3) {
                      return _ref4.apply(this, arguments);
                    };
                  }()).catch(function (error) {
                    console.log(error);
                    return null;
                  });

                case 2:
                  value = _context4.sent;

                  console.log(value);

                  if (!value) {
                    _context4.next = 9;
                    break;
                  }

                  _context4.next = 7;
                  return this.checkDocs();

                case 7:
                  _context4.next = 9;
                  return this.askSomeoneRemind(_id);

                case 9:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function askSomeoneEdit(_x2) {
          return _ref3.apply(this, arguments);
        }

        return askSomeoneEdit;
      }()
    }, {
      key: "saveFile",
      value: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(missingDoc, img) {
          var split, typeList, typeDoc, docs;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  console.log("saveFile", missingDoc, img);

                  split = missingDoc.ref.split(".");
                  typeList = split[0];
                  typeDoc = split[1];
                  docs = void 0;
                  _context5.t0 = typeList;
                  _context5.next = _context5.t0 === "typeDocUser" ? 8 : _context5.t0 === "typeDocVehicle" ? 24 : 40;
                  break;

                case 8:
                  docs = this.driver.docs ? this.driver.docs : [];

                  _context5.t1 = docs;
                  _context5.t2 = missingDoc.name;
                  _context5.t3 = img.thumb;
                  _context5.t4 = img.url;
                  _context5.t5 = typeDoc;
                  _context5.next = 16;
                  return this.CustomListsService.getNameByValue(typeList, typeDoc);

                case 16:
                  _context5.t6 = _context5.sent;
                  _context5.t7 = typeList;
                  _context5.t8 = {
                    value: _context5.t5,
                    name: _context5.t6,
                    list: _context5.t7
                  };
                  _context5.t9 = {
                    name: _context5.t2,
                    thumb: _context5.t3,
                    url: _context5.t4,
                    what: _context5.t8
                  };

                  _context5.t1.push.call(_context5.t1, _context5.t9);

                  _context5.next = 23;
                  return this.UsersService.updateAttributesById(this.driver._id, {
                    docs: docs
                  });

                case 23:
                  return _context5.abrupt("break", 41);

                case 24:
                  docs = this.vehicle.docs ? this.vehicle.docs : [];

                  _context5.t10 = docs;
                  _context5.t11 = missingDoc.name;
                  _context5.t12 = img.thumb;
                  _context5.t13 = img.url;
                  _context5.t14 = typeDoc;
                  _context5.next = 32;
                  return this.CustomListsService.getNameByValue(typeList, typeDoc);

                case 32:
                  _context5.t15 = _context5.sent;
                  _context5.t16 = typeList;
                  _context5.t17 = {
                    value: _context5.t14,
                    name: _context5.t15,
                    list: _context5.t16
                  };
                  _context5.t18 = {
                    name: _context5.t11,
                    thumb: _context5.t12,
                    url: _context5.t13,
                    what: _context5.t17
                  };

                  _context5.t10.push.call(_context5.t10, _context5.t18);

                  _context5.next = 39;
                  return this.VehiclesService.updateAttributesById(this.vehicle._id, {
                    docs: docs
                  });

                case 39:
                  return _context5.abrupt("break", 41);

                case 40:
                  return _context5.abrupt("break", 41);

                case 41:
                  _context5.next = 43;
                  return this.checkDocs();

                case 43:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function saveFile(_x4, _x5) {
          return _ref5.apply(this, arguments);
        }

        return saveFile;
      }()
    }, {
      key: "close",
      value: function close() {
        if (this.$scope.$parent) {
          this.$scope.$parent.$close();
        }
      }
    }, {
      key: "validateEmail",
      value: function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      }
    }, {
      key: "$onInit",
      value: function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!(this.resolve && this.resolve.params)) {
                    _context6.next = 5;
                    break;
                  }

                  this.damage = this.resolve.params.damage;

                  console.log("damage", this.damage);

                  _context6.next = 5;
                  return this.checkDocs();

                case 5:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function $onInit() {
          return _ref6.apply(this, arguments);
        }

        return $onInit;
      }()
    }, {
      key: "checkDocs",
      value: function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
          var insurerEdiMandatoryDocs, docs, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, type, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, doc, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, findInDocs, docToFind, split, typeList, typeDoc, mandatory, _docs;

          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  this.missingDocs = [];

                  this.blockTransmission = false;

                  if (!(this.damage.insurerContract && this.damage.insurerContract.insurerEdiMandatoryDocs)) {
                    _context7.next = 121;
                    break;
                  }

                  insurerEdiMandatoryDocs = this.damage.insurerContract.insurerEdiMandatoryDocs;
                  docs = [];
                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context7.prev = 8;
                  _iterator = Object.keys(insurerEdiMandatoryDocs)[Symbol.iterator]();

                case 10:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context7.next = 34;
                    break;
                  }

                  type = _step.value;
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context7.prev = 15;

                  for (_iterator3 = Object.keys(insurerEdiMandatoryDocs[type])[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    doc = _step3.value;

                    if (insurerEdiMandatoryDocs[type][doc]["copy"] == true) {
                      docs.push(type + "." + doc + "." + insurerEdiMandatoryDocs[type][doc]["mandatory"]);
                    }
                  }
                  _context7.next = 23;
                  break;

                case 19:
                  _context7.prev = 19;
                  _context7.t0 = _context7["catch"](15);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context7.t0;

                case 23:
                  _context7.prev = 23;
                  _context7.prev = 24;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 26:
                  _context7.prev = 26;

                  if (!_didIteratorError3) {
                    _context7.next = 29;
                    break;
                  }

                  throw _iteratorError3;

                case 29:
                  return _context7.finish(26);

                case 30:
                  return _context7.finish(23);

                case 31:
                  _iteratorNormalCompletion = true;
                  _context7.next = 10;
                  break;

                case 34:
                  _context7.next = 40;
                  break;

                case 36:
                  _context7.prev = 36;
                  _context7.t1 = _context7["catch"](8);
                  _didIteratorError = true;
                  _iteratorError = _context7.t1;

                case 40:
                  _context7.prev = 40;
                  _context7.prev = 41;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 43:
                  _context7.prev = 43;

                  if (!_didIteratorError) {
                    _context7.next = 46;
                    break;
                  }

                  throw _iteratorError;

                case 46:
                  return _context7.finish(43);

                case 47:
                  return _context7.finish(40);

                case 48:
                  if (!(this.damage.driverId && this.damage.driverId.length >= 24)) {
                    _context7.next = 54;
                    break;
                  }

                  _context7.next = 51;
                  return this.UsersService.findById({
                    _id: this.damage.driverId.replace("$", ""),
                    filter: {
                      fields: {
                        _id: true,
                        docs: true,
                        firstName: true,
                        lastName: true
                      }
                    }
                  });

                case 51:
                  this.driver = _context7.sent;
                  _context7.next = 55;
                  break;

                case 54:
                  this.driver = { docs: [] };

                case 55:
                  if (!(this.damage.vehicleId && this.damage.vehicleId.length >= 24)) {
                    _context7.next = 61;
                    break;
                  }

                  _context7.next = 58;
                  return this.VehiclesService.findById({
                    _id: this.damage.vehicleId.replace("$", ""),
                    filter: { fields: { _id: true, docs: true } }
                  });

                case 58:
                  this.vehicle = _context7.sent;
                  _context7.next = 62;
                  break;

                case 61:
                  this.vehicle = { docs: [] };

                case 62:
                  _context7.next = 64;
                  return this.DocumentRequestsService.find({
                    filter: {
                      where: {
                        damageId: "$" + this.damage._id
                      }
                    }
                  });

                case 64:
                  this.documentRequests = _context7.sent;

                  console.log("vehicle =", this.vehicle);
                  console.log("driver =", this.driver);

                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context7.prev = 70;
                  _iterator2 = docs[Symbol.iterator]();

                case 72:
                  if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                    _context7.next = 107;
                    break;
                  }

                  findInDocs = function findInDocs(docs, type) {
                    var filterDocs = [];

                    if (docs && docs.length > 0) {
                      var _iteratorNormalCompletion4 = true;
                      var _didIteratorError4 = false;
                      var _iteratorError4 = undefined;

                      try {
                        for (var _iterator4 = docs[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                          var _doc = _step4.value;

                          if (_doc.what && _doc.what.value == type) {
                            filterDocs.push(_doc);
                          }
                        }
                      } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion4 && _iterator4.return) {
                            _iterator4.return();
                          }
                        } finally {
                          if (_didIteratorError4) {
                            throw _iteratorError4;
                          }
                        }
                      }
                    }
                    return filterDocs;
                  };

                  docToFind = _step2.value;
                  split = docToFind.split(".");
                  typeList = split[0];
                  typeDoc = split[1];
                  mandatory = split[2];


                  console.log("check doc for " + docToFind);

                  _docs = findInDocs(this.damage.docs, typeDoc);

                  if (!(_docs.length === 0)) {
                    _context7.next = 104;
                    break;
                  }

                  _context7.t2 = typeList;
                  _context7.next = _context7.t2 === "typeDocVehicle" ? 85 : _context7.t2 === "typeDocUser" ? 87 : 89;
                  break;

                case 85:
                  _docs = findInDocs(this.vehicle.docs, typeDoc);

                  return _context7.abrupt("break", 90);

                case 87:
                  _docs = findInDocs(this.driver.docs, typeDoc);

                  return _context7.abrupt("break", 90);

                case 89:
                  return _context7.abrupt("break", 90);

                case 90:
                  if (!(_docs.length === 0)) {
                    _context7.next = 103;
                    break;
                  }

                  if (!(mandatory == "true")) {
                    _context7.next = 101;
                    break;
                  }

                  this.blockTransmission = true;
                  _context7.t3 = this.missingDocs;
                  _context7.t4 = docToFind;
                  _context7.next = 97;
                  return this.CustomListsService.getNameByValue(typeList, typeDoc);

                case 97:
                  _context7.t5 = _context7.sent;
                  _context7.t6 = mandatory;
                  _context7.t7 = {
                    ref: _context7.t4,
                    name: _context7.t5,
                    mandatory: _context7.t6
                  };

                  _context7.t3.push.call(_context7.t3, _context7.t7);

                case 101:
                  _context7.next = 104;
                  break;

                case 103:
                  if (this.damage.docs && this.damage.docs.length > 0) {
                    this.damage.docs = [].concat(_toConsumableArray(this.damage.docs), _toConsumableArray(_docs));
                  } else {
                    this.damage.docs = _docs;
                  }

                case 104:
                  _iteratorNormalCompletion2 = true;
                  _context7.next = 72;
                  break;

                case 107:
                  _context7.next = 113;
                  break;

                case 109:
                  _context7.prev = 109;
                  _context7.t8 = _context7["catch"](70);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context7.t8;

                case 113:
                  _context7.prev = 113;
                  _context7.prev = 114;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 116:
                  _context7.prev = 116;

                  if (!_didIteratorError2) {
                    _context7.next = 119;
                    break;
                  }

                  throw _iteratorError2;

                case 119:
                  return _context7.finish(116);

                case 120:
                  return _context7.finish(113);

                case 121:

                  this.$timeout(function () {}, 10);

                case 122:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this, [[8, 36, 40, 48], [15, 19, 23, 31], [24,, 26, 30], [41,, 43, 47], [70, 109, 113, 121], [114,, 116, 120]]);
        }));

        function checkDocs() {
          return _ref7.apply(this, arguments);
        }

        return checkDocs;
      }()
    }, {
      key: "send",
      value: function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
          var json;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  console.log("send...");

                  if (!(this.missingDocs.length > 0 && this.blockTransmission == true)) {
                    _context8.next = 6;
                    break;
                  }

                  _context8.next = 4;
                  return swal("Ajouter les documents manquants", "", "error");

                case 4:
                  _context8.next = 32;
                  break;

                case 6:
                  if (this.damage.insurerTransmissionCcEmail) {
                    this.damage.insurerTransmissionCcEmail = this.damage.insurerTransmissionCcEmail.trim();
                  }

                  if (!(this.damage.insurerTransmissionCcEmail && !this.validateEmail(this.damage.insurerTransmissionCcEmail))) {
                    _context8.next = 10;
                    break;
                  }

                  Notiflix.Notify.failure("Le format de l'email en copie n'est pas valide");
                  return _context8.abrupt("return");

                case 10:

                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");

                  _context8.prev = 11;
                  _context8.next = 14;
                  return this.DamagesService.updateAttributesById(this.damage._id, {
                    docs: this.damage.docs,
                    missingDocs: this.missingDocs,
                    insurerTransmissionCcEmail: this.damage.insurerTransmissionCcEmail || null
                  });

                case 14:
                  _context8.prev = 14;
                  _context8.next = 17;
                  return this.DamagesService.customPost("sendToInsurer", {
                    damageId: this.damage._id,
                    templateName: "damage.edi"
                  });

                case 17:
                  json = _context8.sent;

                  if (json && json.success === true) {
                    Notiflix.Notify.success("Envoi réussi");
                  } else {
                    Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + json.info);
                  }
                  _context8.next = 24;
                  break;

                case 21:
                  _context8.prev = 21;
                  _context8.t0 = _context8["catch"](14);

                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context8.t0);

                case 24:
                  Notiflix.Loading.remove();
                  this.close();
                  _context8.next = 32;
                  break;

                case 28:
                  _context8.prev = 28;
                  _context8.t1 = _context8["catch"](11);

                  Notiflix.Notify.failure("Echec de l'envoi à l'assurance : " + _context8.t1.message);
                  Notiflix.Loading.remove();

                case 32:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this, [[11, 28], [14, 21]]);
        }));

        function send() {
          return _ref8.apply(this, arguments);
        }

        return send;
      }()
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    controller: Controller
  });
})();